import { useMutation } from "@tanstack/react-query";
import {
  forgotPassword,
  resetPassword,
  verifyResetToken,
} from "../services/auth-service";

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: forgotPassword,
  });
};

export const useResetPassword = () => {
  return useMutation({
    mutationFn: resetPassword,
  });
};

export const useVerifyResetToken = () => {
  return useMutation({
    mutationFn: verifyResetToken,
  });
};
